export { default } from './StaticPageLanguageLink';
